(() => {
    'use strict';

    const setLocalStorage = widget => {
        const dataPayload = getAnswerPayload(widget);
        howspace.widgets.setLocalStorage(widget, howspace.widgets.form.ANSWERS, dataPayload.answers);
    };

    const setLocalStorageForRetry = widget => {
        const dataPayload = {
            answers: {}
        };

        widget.find('.field').each(function() {
            const field = $(this);
            const fieldId = String(field.data('id'));

            dataPayload.answers[fieldId] = [];

            field.find('.option-wrapper.selected').each(function() {
                const option = $(this);
                let value;

                switch (field.data('type')) {
                    case 'text':
                    case 'number':
                        value = option.find('.title').text().trim();
                        break;

                    case 'date':
                        value = option.data('date');
                        break;

                    default:
                        value = String(option.data('id'));
                        break;
                }

                dataPayload.answers[fieldId].push(value);
            });
        });

        howspace.widgets.setLocalStorage(widget, howspace.widgets.form.ANSWERS, dataPayload.answers);
    };

    const getLocalStorage = widget => {
        const answers = howspace.widgets.getLocalStorage(widget, howspace.widgets.form.ANSWERS);
        if (answers) {
            let firstFieldShown = !widget.data('is-wizard-mode');
            if (!firstFieldShown) {
                widget.find('.field').addClass('d-none');
            }

            const sortDraggableOptions = (sortableListItems, optionIds) => {
                const optionsArray = sortableListItems.find('.option-wrapper').get();

                optionsArray.sort(function(a, b) {
                    const indexA = $.inArray($(a).find('.option').data('id'), optionIds);
                    const indexB = $.inArray($(b).find('.option').data('id'), optionIds);
                    return indexA - indexB;
                });

                sortableListItems.empty().append(optionsArray);
            }

            Object.keys(answers).forEach(function (fieldId) {
                const field = widget.find('.field[data-id="' + fieldId + '"]');
                const optionIds = answers[fieldId];
                if (!firstFieldShown && optionIds.length === 0) {
                    field.removeClass('d-none');
                    firstFieldShown = true;
                }

                if (field.data('type') === 'date') {
                    const datePicker = field.find('.howspace-date-picker');
                    howspace.components.datePicker.setDate(datePicker, optionIds[0]);
                } else if (field.data('subtype') === 'dropdown') {
                    const select = field.find('select');
                    select.val(optionIds[0]);
                } else if (field.data('type') === 'drag') {
                    sortDraggableOptions(field.find('.howspace-sortable-list-items'), optionIds);
                } else if (field.data('type') === 'pair') {
                    const leftOptionIds = optionIds.map(function(pair) {
                        return pair.split(':')[0];
                    });

                    sortDraggableOptions(field.find('.left .howspace-sortable-list-items'), leftOptionIds);

                    const rightOptionIds = optionIds.map(function(pair) {
                        return pair.split(':')[1];
                    });

                    sortDraggableOptions(field.find('.right .howspace-sortable-list-items'), rightOptionIds);
                } else {
                    optionIds.forEach(function (optionId) {
                        const option = field.find('.option[data-id="' + optionId + '"]');
                        if (option.length > 0) {
                            option.find('input').prop('checked', true).trigger('change');
                        } else {
                            const input = field.find('textarea, input[type="text"], input[type="number"]');
                            input.val(optionId).trigger('input');
                            howspace.components.autosize.update(input);
                        }
                    });
                }
            });

            if (!firstFieldShown) {
                widget.find('.field:last').removeClass('d-none');
            }
        }
    };

    const removeLocalStorage = widget => {
        howspace.widgets.removeLocalStorage(widget, howspace.widgets.form.ANSWERS);
    };

    const deleteAnswer = (widget, successFn) => {
        if (widget.data('answer-id')) {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/answer/' + widget.data('answer-id'), {
                type: 'DELETE',
                success: successFn
            });
        } else {
            successFn();
        }
    };

    const upsertAnswer = (widget, completeFn) => {
        if (widget.find('.options-view').length === 0) {
            return;
        }

        const dataPayload = getAnswerPayload(widget);

        if (widget.data('answer-id')) {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/answer/' + widget.data('answer-id'), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.workspace.page.pathMode.handleUserHasInteracted(widget);

                    removeLocalStorage(widget);

                    howspace.scroller.scrollToElement(widget);
                },
                complete: () => {
                    howspace.widgets.updateWidget(widget);
                }
            });
        } else {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/answers', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.workspace.page.pathMode.handleUserHasInteracted(widget);

                    removeLocalStorage(widget);

                    howspace.scroller.scrollToElement(widget);
                },
                complete: () => {
                    if (!completeFn) {
                        howspace.widgets.updateWidget(widget);
                    } else {
                        completeFn();
                    }
                }
            });
        }
    }

    const getOptionIndex = index => {
        return String.fromCharCode(index % 26 + 65);
    };

    const timeoutKey = 'form-equalize-timer';
    const equalizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            scheduleEqualize($(entry.target).closest('.widget'));
        });
    });

    const scheduleEqualize = (widget) => {
        const timeoutId = widget.data(timeoutKey);
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        widget.data(timeoutKey, setTimeout(() => {
            widget.removeData(timeoutKey);
            equalizeOptionHeights(widget);
        }, 16));
    };

    // Equal-height utilities for pair fields: make all .option in each .equal-height-group match tallest
    const equalizeOptionHeights = (widget) => {
        if (widget.data('form-equalizing')) {
            return;
        }
        widget.data('form-equalizing', true);
        try {
            widget.find('.equal-height-group').each(function () {
                const group = $(this);
                const items = group.find('.option');
                if (items.length === 0) {
                    return;
                }

                // Reset to natural height before measuring
                items.css('height', '');

                let maxHeight = 0;
                items.each(function () {
                    const itemHeight = $(this).outerHeight();
                    if (itemHeight > maxHeight) {
                        maxHeight = itemHeight;
                    }
                });

                if (maxHeight > 0) {
                    items.css('height', maxHeight + 'px');
                }
            });
        } finally {
            widget.removeData('form-equalizing');
        }
    };

    // Resize observer for maintaining equal heights in pair questions
    const attachResizeObserver = (widget) => {
        widget.find('.equal-height-group:not(.observing-size)').each((_, el) => {
            el.classList.add('observing-size');
            equalizeObserver.observe(el);
        });
    };

    const detachResizeObserver = (widget) => {
        const timerId = widget.data(timeoutKey);
        if (timerId) {
            clearTimeout(timerId);
            widget.removeData(timeoutKey);
        }
        widget.find('.equal-height-group.observing-size').each((_, el) => {
            el.classList.remove('observing-size');
            equalizeObserver.unobserve(el);
        });
    };

    const validateAnswers = (widget, store = true) => {
        let isComplete = true;

        widget.find('.field').each(function () {
            const field = $(this);

            const textInputs = field.find('textarea, input[type="text"], input[type="number"]');
            const emptyText = textInputs.length > 0 && textInputs.filter(function(){
                return $(this).val().trim() === "";
            }).length > 0;

            const checks = field.find('input[type="radio"], input[type="checkbox"]');
            const unchecked = checks.length > 0 && checks.filter(":checked").length === 0;

            const selects = field.find('select');
            const emptySelect = selects.length > 0 && selects.filter(function() {
                return $(this).val() === null || $(this).val() === "";
            }).length > 0;

            if (field.hasClass('required') && (emptyText || unchecked || emptySelect)) {
                field.find('.next-btn').prop('disabled', true);
                isComplete = false;
                return false;
            } else {
                field.find('.next-btn').prop('disabled', false);
            }
        });

        if (store) {
            setLocalStorage(widget);
        }

        widget.find('.submit-btn').prop('disabled', !isComplete);
    };

    const getAnswerPayload = widget => {
        const dataPayload = {
            answers: {}
        };

        widget.find('.field').each(function () {
            const field = $(this);
            const fieldId = String(field.data('id'));

            dataPayload.answers[fieldId] = [];

            if (field.data('type') === 'pair') {
                field.find('.left .option').each(function () {
                    const option = $(this);
                    const optionId = String(option.data('id'));

                    dataPayload.answers[fieldId].push(optionId);
                });

                let fieldIndex = 0;
                field.find('.right .option').each(function () {
                    const option = $(this);
                    const optionId = String(option.data('id'));
                    const leftOptionId = dataPayload.answers[fieldId][fieldIndex];
                    dataPayload.answers[fieldId][fieldIndex] = leftOptionId + ':' + optionId;
                    fieldIndex++;
                });
            } else if (field.data('type') === 'drag') {
                field.find('.option').each(function () {
                    const option = $(this);
                    const optionId = String(option.data('id'));

                    dataPayload.answers[fieldId].push(optionId);
                });
            } else if (field.data('subtype') === 'dropdown') {
                field.find('select').each(function () {
                    const select = $(this);
                    dataPayload.answers[fieldId].push(select.val());
                });
            } else if (field.data('type') === 'text') {
                field.find('textarea, input[type="text"]').each(function () {
                    const input = $(this);
                    dataPayload.answers[fieldId].push(input.val().trim());
                });
            } else if (field.data('type') === 'number') {
                field.find('input[type="number"]').each(function () {
                    const input = $(this);
                    dataPayload.answers[fieldId].push(input.val().trim());
                });
            } else if (field.data('type') === 'date') {
                dataPayload.answers[fieldId].push(field.find('.howspace-date-picker').data('date'));
            } else {
                field.find('.option:has(input:checked)').each(function () {
                    const option = $(this);
                    const optionId = String(option.data('id'));

                    dataPayload.answers[fieldId].push(optionId);
                });
            }
        });

        return dataPayload;
    };

    const addField = e => {
        const btn = $(e.target);
        const widget = btn.closest('.widget');
        const fieldType = btn.data('type');
        const fieldSubType = btn.data('subtype');

        const sortableList = widget.find('.howspace-sortable-list.fields');
        sortableList.find('.card-title.howspace-collapse-initialized').each(function () {
            howspace.components.collapse.collapse(this, false);
        });
        const newField = howspace.components.sortableList.addItemByClass(sortableList, fieldType);

        // Card ID
        howspace.components.card.setId(newField);
        howspace.components.card.setId(newField.find('.attachment-card'));

        // Field index
        const index = sortableList.find('.field').length;
        const header = newField.find('> .card-header');
        header.data('index', index);
        header.find('.card-title').html(header.find('.card-title').html() + index);
        header.find('input').val(header.find('input').val() + index);

        // Field type
        newField.dataAndAttr('type', fieldType);
        newField.dataAndAttr('subtype', fieldSubType);
        newField.find('input[name=type]').val(fieldType);
        newField.find('input[name=subtype]').val(fieldSubType);

        // Scroll to the element
        howspace.scroller.scrollToElement(newField);

        // Add default options
        if (fieldSubType === 'scale') {
            for (let i = 1; i <= 5; i++) {
                addOption(newField, String(i));
            }
        } else if (fieldSubType === 'boolean') {
            addOption(newField, howspace.translate('form_field_type_boolean_true'));
            addOption(newField, howspace.translate('form_field_type_boolean_false'));
        } else if (fieldType === 'text' || fieldType === 'number' || fieldType === 'date') {
            // do nothing
        } else {
            addOption(newField);
            addOption(newField);
        }
    };

    const addOption = (field, title = '') => {
        const sortableList = field.find('.howspace-sortable-list.options');
        const newOption = howspace.components.sortableList.addItem(sortableList);

        // Field type
        switch (field.find('input[name=type]').val()) {
            case 'radio':
                newOption.find('.howspace-form-radio-button input').attr('name', 'is_correct_' + field.prop('id'));
                break;
        }

        // Option index
        const count = sortableList.find('.option').length - 1;
        if (count === 0) {
            newOption.find('input:first').click();
        }
        newOption.find('.index').text(getOptionIndex(count));

        // Title
        newOption.find('input[name="title"]').val(title);
    };

    const updateCounter = (widget) => {
        const alert = widget.find('.alert');
        const expiresAt = widget.data('answer-expires');
        const now = Math.floor(Date.now() / 1000);
        const remainingSeconds = expiresAt - now;

        if (remainingSeconds <= 0) {
            stopCounter(widget);

            howspace.form.disable(widget);
            widget.find('.submit-btn').prop('disabled', true);
            alert.removeClass('alert-warning').addClass('alert-danger');

            upsertAnswer(widget);
        }

        const minutes = Math.floor(remainingSeconds / 60);
        const seconds = remainingSeconds % 60;

        const formattedTime = (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);

        alert.html(howspace.translate('form_timed_exam_alert', {remaining: formattedTime}));
    };

    const stopCounter = widget => {
        clearInterval(widget.data('timer'));
    };

    howspace.widgets.form = {
        ANSWERS: 'answers',
        initView: widget => {
            // Field inputs.
            widget.find('input[type="radio"]').on('change', () => validateAnswers(widget));
            widget.find('input[type="checkbox"]').on('change', () => validateAnswers(widget));
            widget.find('textarea, input[type="text"], input[type="number"]').on('input', () => validateAnswers(widget));
            widget.find('select').on('change', () => validateAnswers(widget));
            widget.on(howspace.components.sortableList.ITEM_MOVED, () => validateAnswers(widget));
            widget.on(howspace.components.datePicker.DATE_CHANGED, () => validateAnswers(widget));
            widget.on(howspace.components.datePicker.DATE_PICKER_CLEARED, () => validateAnswers(widget));

            // Options.
            widget.find('.option-wrapper .option').on('click', function(e) {
                if (!$(e.target).is('input')) {
                    const input = $(this).find('input');
                    if (input.prop('type') === 'radio') {
                        input.prop('checked', true).trigger('change');
                    } else if (input.prop('type') === 'checkbox') {
                        input.prop('checked', !input.prop('checked')).trigger('change');
                    }
                }
            });

            // Start button.
            widget.find('.start-btn').on('click', e => {
                // Prevent double clicks
                const btn = $(e.target);
                real.button.loading(btn, widget);

                real.ajax.json(howspace.widgets.getApiUrl(widget) + '/answers', {
                    type: 'POST',
                    complete: () => {
                        howspace.widgets.updateWidget(widget);
                    }
                });
            });

            // Back button.
            widget.find('.back-btn').on('click', e => {
                const btn = $(e.target);
                const field = btn.closest('.field');
                field.addClass('d-none');
                field.prev('.field').removeClass('d-none');
            });

            // Next button.
            widget.find('.next-btn').on('click', e => {
                const btn = $(e.target);
                const field = btn.closest('.field');
                field.addClass('d-none');
                field.next('.field').removeClass('d-none');
            });

            const optionsView = widget.find('.options-view');
            const resultsView = widget.find('.results-view');

            // Submit answers button.
            widget.find('.submit-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);

                stopCounter(widget);

                if (widget.data('is-allow-multiple-answers')) {
                    upsertAnswer(widget, () => {
                        real.button.reset(widget.find('.submit-again-btn'), widget);

                        optionsView.addClass('d-none');
                        resultsView.removeClass('d-none');
                    });
                } else {
                    upsertAnswer(widget);
                }
            });

            // Submit again button.
            widget.find('.submit-again-btn').on('click', () => {
                howspace.widgets.updateWidget(widget);
            });

            // Try again button.
            widget.find('.retry-btn').on('click', e => {
                if (!widget.data('widget-subtype')) {
                    setLocalStorageForRetry(widget);
                }

                // Prevent double clicks
                const btn = $(e.target);
                real.button.loading(btn, widget);

                deleteAnswer(widget, () => {
                    howspace.workspace.page.pathMode.handleUserHasNotInteracted(widget);
                    howspace.widgets.updateWidget(widget);
                });
            });

            // Timer.
            if (widget.data('answer-expires')) {
                widget.dataAndAttr('timer', setInterval(() => updateCounter(widget), 200))

                updateCounter(widget);
            }

            getLocalStorage(widget);
            validateAnswers(widget, false);

            // Equal-height behavior for pair type questions
            attachResizeObserver(widget);
            scheduleEqualize(widget);
        },
        destroyView: widget => {
            stopCounter(widget);
            detachResizeObserver(widget);
        },
        initEdit: widget => {
            // Add field button.
            widget.find('.add-field-btn').on('click', addField);

            // Add option button.
            widget.on('click', '.add-field-option-btn', e => addOption($(e.target).closest('.field')));

            // Item moved event.
            widget.on(howspace.components.sortableList.ITEM_MOVED, item => {
                const target = $(item.target);
                if (target.hasClass('fields')) {
                    target.find('.field').each(function (index) {
                        const field = $(this);
                        const title = field.find('> .card-header .card-title');
                        title.html(title.html().trim().replace(/\d+$/, index + 1));
                    });
                } else {
                    $(item.target).find('.option').each(function (index) {
                        $(this).find('.index').text(getOptionIndex(index));
                    });
                }
                // Re-equalize if a pair field was affected
                scheduleEqualize(widget);
            });

            // Field expanding event.
            widget.on(howspace.components.collapse.EXPANDING, '.field', e => {
                const card = $(e.target).closest('.card');
                if (!card.hasClass('field')) {
                    return;
                }
                card.siblings().each(function () {
                    howspace.components.collapse.collapse($(this).find('> .card-header .card-title.howspace-collapse-initialized'));
                });
            });

            // Allow try again / multiple answers checkboxes.
            widget.find('.allow-try-again-checkbox input').on('change', e => {
                const input = $(e.target);
                const otherCheckbox = widget.find('.allow-multiple-answers-checkbox');
                if (input.is(':checked')) {
                    otherCheckbox.find('input').prop('checked', false);
                    howspace.form.disable(otherCheckbox);
                } else {
                    howspace.form.enable(otherCheckbox);
                }
            });

            widget.find('.allow-multiple-answers-checkbox input').on('change', e => {
                const input = $(e.target);
                const otherCheckbox = widget.find('.allow-try-again-checkbox');
                if (input.is(':checked')) {
                    otherCheckbox.find('input').prop('checked', false);
                    howspace.form.disable(otherCheckbox);
                } else {
                    howspace.form.enable(otherCheckbox);
                }
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            // fields
            dataPayload.fields = [];
            widget.find('.field:not(.deleted)').each(function () {
                const field = $(this);
                const fieldDataPayload = real.form.getDataPayload(field);
                fieldDataPayload.options = [];
                field.find('.option-wrapper:not(.deleted)').each(function () {
                    const option = $(this);
                    const optionDataPayload = real.form.getDataPayload(option);
                    fieldDataPayload.options.push(optionDataPayload);
                });
                dataPayload.fields.push(fieldDataPayload);
            });

            // try again
            if (dataPayload.results) {
                if (dataPayload.results.allow_try_again_limit === undefined) {
                    dataPayload.results.allow_try_again_limit = 0;
                }
            }

            // duration
            if (dataPayload.duration === undefined) {
                dataPayload.duration = 0;
            }

            return dataPayload;
        },
        initResultsModal: modal => {
            modal = $(modal);

            modal.on(howspace.components.lister.LIST_ITEMS_RENDERED, (e) => {
                const lister = $(e.target);
                const container = lister.closest('.exam-results-content');
                const sendEmailButtons = container.find('.send-emails-btn');

                if (lister.data('total-items') === 0) {
                    sendEmailButtons.prop('disabled', true);
                    sendEmailButtons.addClass('disabled');
                } else {
                    sendEmailButtons.prop('disabled', false);
                    sendEmailButtons.removeClass('disabled');
                }
            });

            modal.find('.show-more-btn').on('click', e => {
                const btn = $(e.target);
                const field = btn.closest('.field');
                field.find('.option-wrapper').removeClass('d-none');
                btn.remove();
                // Re-equalize when revealing hidden options
                const widget = modal.closest('.widget');
                scheduleEqualize(widget);
            });
        }
    };
})();
